export const Types = {
  LOGIN: 'LOGIN',
  ADD_USER: 'ADD_USER',
  UPDATE_USER: 'UPDATE_USER',
  UPDATE_PROFILE_PICTURE: 'UPDATE_PROFILE_PICTURE',
  FORM_SUBMITION_STATUS: 'FORM_SUBMITION_STATUS',
  /////////////////////////////////////////
  ADD_AUDIT_SCHEDULE:'ADD_AUDIT_SCHEDULE',
  GET_AUDIT_SCHEDULE:'GET_AUDIT_SCHEDULE',
  
  ADD_AUDIT_CHECKLIST:'ADD_AUDIT_CHECKLIST',
  GET_AUDIT_CHECKLIST: 'GET_AUDIT_CHECKLIST',

  ADD_ELLP: 'ADD_ENGINE_LLP',
  GET_ELLPS: 'GET_ENGINE_LLPS',

  SAVE_USER_TOKEN: 'SAVE_USER_TOKEN',
  DEL_USER_TOKEN:'DEL_USER_TOKEN',
  USE_REFRESH_TOKEN: 'USE_REFRESH_TOKEN',

  ADD_AVAILABLE_LEAVE: 'ADD_AVAILABLE_LEAVE',
  ADD_LEAVE_POLICY: 'ADD_LEAVE_POLICY',
  ADD_PUBLIC_HOLIDAY:'ADD_PUBLIC_HOLIDAY',
  ADD_ALERTS: 'ADD_ALERTS',
  ADD_CALENDAR_EVENTS: 'ADD_CALENDAR_EVENTS',
  GET_MESSAGES: 'GET_MESSAGES',

  PROC_ADD_DEMAND_ITEM: 'PROC_ADD_DEMAND_ITEM',
  PROC_UPD_DEMAND_ITEM: 'PROC_UPD_DEMAND_ITEM',
  PROC_DEL_DEMAND_ITEM: 'PROC_DEL_DEMAND_ITEM',
  //////////////////////////////////////////

  

  GET_SIDEBAR_ITEMS: 'GET_SIDEBAR_ITEMS',
  DEL_SIDEBAR_ITEMS: 'DEL_SIDEBAR_ITEMS',
}
